<template>
  <div>
    <modal
      name="print-positions-modal"
      width="900px"
      height="auto"
      :draggable="false"
      :scrollable="true"
      :click-to-close="false"
    >
      <print-positions-manager
        :initial-positions="unavailablePrintPositions"
        :edit-id="editId"
        :variant-sku="selectedVariant ? selectedVariant.sku : ''"
        :context="'wizard'"
        :language-code="languageInUse"
        :tok="tok"
        :sap-customer-id="sapCustomerId"
        @wizard:price-params-changed="
          (event) => $emit('wizard:price-params-changed', event)
        "
        @wizard:print-position-edit="
          (event, newPositionId, oldPositionId) =>
            $emit(
              'wizard:print-position-edit',
              event,
              newPositionId,
              oldPositionId
            )
        "
        @action:print-techniques-see-more-details="
          () => $emit('action:print-techniques-see-more-details')
        "
        @print-position:action="$emit('print-position:action')"
      />
    </modal>
  </div>
</template>
<script>
import PrintPositionsManager from '../../../print-positions-manager/print-positions-manager.vue';
import { useStore as useProductStore } from '@/stores/product';
import { useStore as useLangStore } from '@/stores/product';
import { mapActions, mapState, mapStores } from 'pinia';

export default {
  components: {
    PrintPositionsManager,
  },
  props: {
    sapCustomerId: {
      type: String,
      required: true,
    },
    editId: {
      type: String,
      required: true,
    },
    tok: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState(useProductStore, [
      'selectedPrintPosition',
      'selectedVariant',
      'unavailablePrintPositions',
      'isProductPrintable',
      'data',
      'printPositions',
      'activePosition',
    ]),
    ...mapState(useLangStore, ['languageInUse']),
  },
};
</script>
<style lang=""></style>
